'use strict';

// Context type list available
module.exports = {
  client: 'client',
  group: 'group',
  challenge: 'challenge',
};
